<script lang="ts">
  import { AppState } from '../../etc/stores';
  import InfoPostCheckout from '../icons/InfoPostCheckout.svelte';

  export let title: string = '';
  export let description: string = '';

  const { primary600, typography } = $AppState.theme.colors;
</script>

<div class="info-container" style={`background: ${primary600};`}>
  <div class="info-icon">
    <InfoPostCheckout color={typography} />
  </div>
  <div>
    <p class="info-title" style={`color: ${typography};`}>
      {title}
    </p>
    <p class="info-description" style={`color: ${typography};`}>
      {description}
    </p>
  </div>
</div>

<style lang="scss">
  .info {
    &-container {
      width: 100%;
      background: $color-white;
      box-sizing: border-box;
      border-radius: 8px;
      padding: 16px;

      display: flex;
      flex-flow: row nowrap;
    }
    &-title {
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
    }
    &-description {
      font-size: 14px;
      line-height: 21px;
      margin-top: 8px;
    }

    &-icon {
      min-width: 20px;
      height: 20px;
      margin-right: 14px;
    }
  }
</style>
